import 'css-doodle'
import Footer from "./Footer/Footer"
import Headline from "../components/Headline"

import HomeImg1 from "../static/image/Startseite-1-low.jpg"
import HomeImgMobile from "../static/image/Startseite-1-mobile-hochformat-low.jpg"

import useWindowResize from "../hooks/useWindowResize"
import { useEffect, useRef, useState } from "react"
import ContentModule from "../components/ContentModule"
import { useLocation } from "react-router-dom"
import Container from "../components/Container"
import useStories from "../hooks/useStories"
import usePageText from "../hooks/usePageText"
import Loader from "../components/Loader"
import useRandom from "../hooks/useRandom"
import useStoryFoldStates from "../hooks/useStoryFoldStates"
import Title from '../components/Title'

import HomeStatic1 from '../static/image/Startseite-01-low.jpeg'
import HomeStatic2 from '../static/image/images-260802/Startseite-u1.jpg'
import HomeStatic3 from '../static/image/images-260802/Startseite-u2.jpg'
import HeadlineMagic from '../components/HeadlineMagic'


const Home = () => {

  const { isMobile } = useWindowResize()
  const [menuIsOpen, setMenuIsOpen] = useState(false)

  const location = useLocation()

  const { seed } = useRandom(5)
  const { stories, loading: storiesLoading } = useStories("HOME")
  const { storyFoldStates, onModuleFoldStateChanged } = useStoryFoldStates(stories)
  const { pageText, loading: pageTextLoading } = usePageText("HOME")

  const headlineRef = useRef<HTMLDivElement>(null)


  useEffect(() => {
    if (location && location.state && location.state.logoClicked) {
      window.scrollTo(0, 0)
      location.state.logoClicked = false
    }
  }, [location, location.state])

  const handleLogoClicked = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const onMenuIsOpenChanged = (menuIsOpen: boolean) => {
    setMenuIsOpen(menuIsOpen)
  }

  useEffect(() => {
    if (menuIsOpen) {
      document.body.style.overflow = 'hidden';
    }
    else {
      document.body.style.overflow = 'visible';
    }
  }, [menuIsOpen]
  )

  return (
    <div className="bg-beige min-w-80">

      <Headline ref={headlineRef} handleLogoClick={handleLogoClicked}
        menuIsOpen={menuIsOpen}
        onMenuIsOpenChanged={onMenuIsOpenChanged}
      />

      <HeadlineMagic headlineRef={headlineRef} />

      {
        /* Second screen */
        <div>

          {
            // Header
            <div className='w-full'>
              <div className={`mx-auto max-w-6xl h-[20rem] flex justify-center items-center text-center bg-cover bg-center`}
                style={{ backgroundImage: `url(${isMobile ? HomeImgMobile : HomeImg1})` }}>
                <Title className={`${isMobile ? "text-4xl" : "text-5xl"}`} marginTop='0'>
                  Herzlich <br /> Willkommen
                </Title>
              </div>
            </div>

          }



          <div>
            {
              // Page Text
              <Container>
                <div className={`${isMobile ? "mt-6" : "mt-16"}`} dangerouslySetInnerHTML={{ __html: pageText }} />
              </Container>
            }

            <Container className='mt-6' paddingMobile={false}>
              {
                stories.map((story) => {
                  return (
                    <ContentModule
                      foldState={storyFoldStates?.find(s => s.id === story.id)?.foldState}
                      onFoldStateChanged={(unfold) => onModuleFoldStateChanged(story.id, unfold)}
                      story={story}
                    />
                  )
                })
              }
            </Container>


            {
              // Loader
              (pageTextLoading || storiesLoading) && <Loader seed={seed} />
            }

          </div>


          {
            // STATIC IMAGE
            <Container paddingMobile={false}>
              <img alt="Home" src={HomeStatic1} className={`w-full h-auto ${isMobile ? "mt-4" : "mb-24 mt-16"}`} />
            </Container>
          }

          {
            // STATIC IMAGE
            <Container paddingMobile={false}>
              <img alt="Home" src={HomeStatic2} className={`w-full h-auto ${isMobile ? "mt-4" : "mb-24 mt-16"}`} />
            </Container>
          }

          {
            // STATIC IMAGE
            <Container paddingMobile={false}>
              <img alt="Home" src={HomeStatic3} className={`w-full h-auto ${isMobile ? "mt-4" : "mb-24 mt-16"}`} />
            </Container>
          }

        </div>
      }

      {
        <Footer />
      }
    </div>
  )
}

export default Home